"use client"

import React, { useMemo } from 'react'
import sanitizeHtml from 'sanitize-html'

interface HTMLRendererProps {
  content: string
  className?: string
}

const HTMLRenderer: React.FC<HTMLRendererProps> = ({ content, className = "" }) => {
  const sanitizedContent = useMemo(() => {
    let rawContent = content || ""
    if (!rawContent.includes('<p>') && !rawContent.includes('<br') && !rawContent.includes('<div')) {
      rawContent = rawContent.replace(/\n/g, '<br />')
    }
    return sanitizeHtml(rawContent, ({
      allowedTags: [
        'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li', 'blockquote', 'a', 'span', 'div', 'img', 'code', 'pre'
      ],
  // some sanitize-html versions don't include this option in its TS defs; cast to any
  // @ts-ignore-next-line
  disallowedTagsMode: 'escape',
      allowedAttributes: {
        a: ['href', 'target', 'rel', 'title', 'class', 'id'],
        img: ['src', 'alt', 'title', 'class', 'style', 'id'],
        '*': ['class', 'style', 'id']
      },
      allowedSchemes: ['http', 'https', 'mailto', 'tel', 'data'],
      allowProtocolRelative: true
    } as any))
  }, [content])

  return (
    <div 
      className={`rich-content ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      style={{ fontFamily: 'Montserrat, sans-serif' }}
    />
  )
}

export default HTMLRenderer